(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pdp-design-details"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll('.vpv-design-details__pause').forEach(function (btn) {
      var media = btn.closest('.vpv-design-details__media');
      var video = media && media.querySelector('video');
      if (!video) return;
      btn.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          btn.classList.remove('is-paused');
          btn.setAttribute('aria-label', 'Pause video');
        } else {
          video.pause();
          btn.classList.add('is-paused');
          btn.setAttribute('aria-label', 'Play video');
        }
      });
    });

    // Mouse click-drag to scroll (trackpad/touch already scroll natively; restricted
    // to the mouse pointer so it doesn't fight native touch scrolling).
    document.querySelectorAll('.vpv-design-details__track').forEach(function (track) {
      var down = false, startX = 0, startScroll = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 3) moved = true;
        track.scrollLeft = startScroll - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false;
        track.classList.remove('is-dragging');
      });
      // Swallow the click that ends a drag so it can't fire the pause button.
      track.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vpv-collection"] && !Shopify.designMode) return;
  try {
    
  // BATCH filtering: nothing applies until "Apply Filters" is pressed. The instant
  // per-tick apply is disabled by NOT giving the filter inputs the `.tag-list` class
  // theme.Collection.initFilters requires (it bails, so it never binds the form
  // `input` listener). Apply then commits everything staged in one navigation to the
  // filtered URL — same mechanism theme.Collection's Sort control already uses — which
  // also dismisses the panel (the page reloads). Delegated on document so it survives
  // any re-render. Active-filter chips stay plain links (navigate to remove).
  document.addEventListener('click', function (evt) {
    var applyBtn = evt.target.closest('[data-vpv-filter-apply]');
    if (!applyBtn) return;
    evt.preventDefault();
    var panel = applyBtn.closest('.vpv-filter-panel');
    var form = panel && panel.querySelector('.filter-form');
    if (!form) return;
    // Checked filter inputs + price inputs → URL params. Unchecked boxes are omitted;
    // empty-valued entries (an untouched price slider) are skipped so they don't add
    // stray `filter...=` params to the URL.
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (value !== '') params.append(key, value);
    });
    // Preserve the current sort; drop pagination so results start on page 1.
    var current = new URLSearchParams(window.location.search);
    if (current.get('sort_by')) params.set('sort_by', current.get('sort_by'));
    var qs = params.toString();
    window.location.href = qs ? window.location.pathname + '?' + qs : window.location.pathname;
  });

  // BATCH the price slider too. theme.PriceRange binds a noUiSlider `change` handler
  // that (a) writes the values into the form inputs AND (b) instantly applies (AJAX).
  // We keep (a) but drop (b): once the slider is initialised, swap its `change`
  // handler for one that only mirrors the values into the inputs, so the price stages
  // like every other filter and commits on Apply (the Apply handler reads those inputs
  // via FormData). The `update` handler (live labels while dragging) is left intact.
  // theme.Collection.initPriceRange runs on load; poll until noUiSlider exists, then
  // rebind once. (No AJAX re-init happens in batch mode, so this runs a single time.)
  function vpvBatchPriceSlider() {
    var sliderEl = document.querySelector('.vpv-filter-panel .price-range__slider');
    if (!sliderEl || !sliderEl.noUiSlider) return false;
    if (sliderEl.dataset.vpvBatched) return true;
    sliderEl.dataset.vpvBatched = '1';
    sliderEl.noUiSlider.off('change');
    sliderEl.noUiSlider.on('change', function (values) {
      var range = sliderEl.closest('.price-range');
      if (!range) return;
      var minInput = range.querySelector('.price-range__input-min');
      var maxInput = range.querySelector('.price-range__input-max');
      if (minInput) minInput.value = values[0];
      if (maxInput) maxInput.value = values[1];
    });
    return true;
  }
  if (!vpvBatchPriceSlider()) {
    var vpvPriceTries = 0;
    var vpvPricePoll = setInterval(function () {
      if (vpvBatchPriceSlider() || ++vpvPriceTries > 40) clearInterval(vpvPricePoll);
    }, 50);
  }

  // Remove the active PRICE chip. Shopify has no single "remove price" URL for a
  // range, so strip BOTH price params from the current URL (keeping every other
  // filter + the sort) and navigate. Delegated so it survives re-renders.
  document.addEventListener('click', function (evt) {
    var chip = evt.target.closest('[data-vpv-remove-price]');
    if (!chip) return;
    evt.preventDefault();
    var names = (chip.getAttribute('data-price-params') || '').split(',');
    var params = new URLSearchParams(window.location.search);
    names.forEach(function (n) { if (n) params.delete(n); });
    var qs = params.toString();
    window.location.href = qs ? window.location.pathname + '?' + qs : window.location.pathname;
  });

  // "What's My Width?" — its own expander, a sibling of the Width collapse region.
  // The main trigger toggles; the in-panel X (data-vpv-width-help-close) always closes.
  // Delegated on document so it survives AJAX re-renders.
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-vpv-width-help-toggle], [data-vpv-width-help-close]');
    if (!btn) return;
    var help = btn.closest('[data-vpv-width-help]');
    if (!help) return;
    var panel = help.querySelector('.vpv-width-help__panel');
    if (!panel) return;
    var mainToggle = help.querySelector('[data-vpv-width-help-toggle]');
    var isClose = btn.hasAttribute('data-vpv-width-help-close');
    var open = isClose ? false : panel.hasAttribute('hidden');   // X always closes; trigger toggles
    if (open) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
    if (mainToggle) mainToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // Collapse "What's My Width?" whenever the WIDTH filter group is toggled (open OR
  // close), so the guide never persists open across a Width toggle. (Visibility itself
  // is CSS — Width-trigger:not(.is-open) ~ .vpv-width-help.)
  document.addEventListener('click', function (evt) {
    var groupTrigger = evt.target.closest('.vpv-filter-group__trigger');
    if (!groupTrigger) return;
    var group = groupTrigger.closest('.vpv-filter-group');
    var help = group && group.querySelector('[data-vpv-width-help]');
    if (!help) return;   // only the Width group has one
    var panel = help.querySelector('.vpv-width-help__panel');
    var toggle = help.querySelector('[data-vpv-width-help-toggle]');
    if (panel) panel.setAttribute('hidden', '');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vpv-pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var APP_ID = 'all-reviews';
    var HIDDEN = 'vpv-reviews-app--hidden';

    function smoothScrollTo(el) {
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // Reveal the reviews app (if "Hide on load") and smooth-scroll to it.
    function showAndScroll() {
      var app = document.getElementById(APP_ID);
      if (!app) return null;
      app.classList.remove(HIDDEN);
      // Let layout settle after un-hiding, then scroll.
      requestAnimationFrame(function () { smoothScrollTo(app); });
      return app;
    }

    // Fire Okendo's own "Write a Review" control (opens its form in a new window).
    // Clicking the real anchor keeps its target="_blank" behaviour and avoids the
    // popup blocker (we're inside a user gesture).
    function triggerWriteReview() {
      var link = document.querySelector('a.oke-w-writeReview, .oke-w-reviews-writeReview a');
      if (link) {
        link.click();
        return true;
      }
      return false;
    }

    document.addEventListener('click', function (e) {
      // Product rating → smooth-scroll to its target section (#reviews). The plain
      // anchor jump is the no-JS fallback (e.g. if this section isn't on the page).
      var ratingLink = e.target.closest('a.product-rating__link');
      if (ratingLink) {
        var href = ratingLink.getAttribute('href') || '';
        if (href.charAt(0) === '#') {
          var target = document.getElementById(href.slice(1));
          if (target) {
            e.preventDefault();
            smoothScrollTo(target);
          }
        }
        return;
      }

      var btn = e.target.closest('[data-vpv-reviews-action]');
      if (!btn) return;
      var action = btn.getAttribute('data-vpv-reviews-action');

      if (action === 'show-reviews') {
        showAndScroll();
      } else if (action === 'write-review') {
        showAndScroll();
        triggerWriteReview();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vpv-search"] && !Shopify.designMode) return;
  try {
    
    // BATCH filtering (identical model to vpv-collection): nothing applies until
    // "Apply Filters" — then everything staged commits in one navigation to the
    // filtered URL. The one search-specific addition: preserve `q` (and the product
    // `type` scope) so applying a filter never loses the search query.
    document.addEventListener('click', function (evt) {
      var applyBtn = evt.target.closest('[data-vpv-filter-apply]');
      if (!applyBtn) return;
      evt.preventDefault();
      var panel = applyBtn.closest('.vpv-filter-panel');
      var form = panel && panel.querySelector('.filter-form');
      if (!form) return;
      var params = new URLSearchParams();
      new FormData(form).forEach(function (value, key) {
        if (value !== '') params.append(key, value);
      });
      var current = new URLSearchParams(window.location.search);
      if (current.get('q')) params.set('q', current.get('q'));
      if (current.get('type')) { params.set('type', current.get('type')); }
      else { params.set('type', 'product'); }
      if (current.get('sort_by')) params.set('sort_by', current.get('sort_by'));
      window.location.href = window.location.pathname + '?' + params.toString();
    });

    // BATCH the price slider (mirror vpv-collection): keep the value-mirroring `change`
    // handler, drop the instant-apply, so price stages like every other filter.
    function vpvSearchBatchPriceSlider() {
      var sliderEl = document.querySelector('.vpv-filter-panel .price-range__slider');
      if (!sliderEl || !sliderEl.noUiSlider) return false;
      if (sliderEl.dataset.vpvBatched) return true;
      sliderEl.dataset.vpvBatched = '1';
      sliderEl.noUiSlider.off('change');
      sliderEl.noUiSlider.on('change', function (values) {
        var range = sliderEl.closest('.price-range');
        if (!range) return;
        var minInput = range.querySelector('.price-range__input-min');
        var maxInput = range.querySelector('.price-range__input-max');
        if (minInput) minInput.value = values[0];
        if (maxInput) maxInput.value = values[1];
      });
      return true;
    }
    if (!vpvSearchBatchPriceSlider()) {
      var vpvSearchPriceTries = 0;
      var vpvSearchPricePoll = setInterval(function () {
        if (vpvSearchBatchPriceSlider() || ++vpvSearchPriceTries > 40) clearInterval(vpvSearchPricePoll);
      }, 50);
    }

    // Remove the active PRICE chip — strip BOTH price params from the current URL
    // (q + every other filter preserved) and navigate.
    document.addEventListener('click', function (evt) {
      var chip = evt.target.closest('[data-vpv-remove-price]');
      if (!chip) return;
      evt.preventDefault();
      var names = (chip.getAttribute('data-price-params') || '').split(',');
      var params = new URLSearchParams(window.location.search);
      names.forEach(function (n) { if (n) params.delete(n); });
      var qs = params.toString();
      window.location.href = qs ? window.location.pathname + '?' + qs : window.location.pathname;
    });

    // "What's My Width?" in-panel expander (mirror vpv-collection).
    document.addEventListener('click', function (evt) {
      var btn = evt.target.closest('[data-vpv-width-help-toggle], [data-vpv-width-help-close]');
      if (!btn) return;
      var help = btn.closest('[data-vpv-width-help]');
      if (!help) return;
      var pnl = help.querySelector('.vpv-width-help__panel');
      if (!pnl) return;
      var mainToggle = help.querySelector('[data-vpv-width-help-toggle]');
      var isClose = btn.hasAttribute('data-vpv-width-help-close');
      var open = isClose ? false : pnl.hasAttribute('hidden');
      if (open) { pnl.removeAttribute('hidden'); } else { pnl.setAttribute('hidden', ''); }
      if (mainToggle) mainToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    document.addEventListener('click', function (evt) {
      var groupTrigger = evt.target.closest('.vpv-filter-group__trigger');
      if (!groupTrigger) return;
      var group = groupTrigger.closest('.vpv-filter-group');
      var help = group && group.querySelector('[data-vpv-width-help]');
      if (!help) return;
      var pnl = help.querySelector('.vpv-width-help__panel');
      var toggle = help.querySelector('[data-vpv-width-help-toggle]');
      if (pnl) pnl.setAttribute('hidden', '');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });

  } catch(e) { console.error(e); }
})();
})();
